import { isDev } from "./is-dev";

export const storeName = isDev ? "persist-state" : "encrypted-state";
